import { storyblokEditable } from '@storyblok/react'
import { MapStoryblok } from '@/component-types-sb'

export default function Map({ blok }: { blok: MapStoryblok }) {
  return (
    <div {...storyblokEditable(blok)} className="max-w-[1200px] mx-auto px-5 pb-10 md:px-10">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10853.209018886839!2d9.0272533!3d47.1519344!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xac0abf136740abb7!2sFoma-Galvanik+AG!5e0!3m2!1sde!2sch!4v1468501879494"
        width="100%"
        height="450"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen
      />
    </div>
  )
}
